// extracted by mini-css-extract-plugin
export default {"link":"common-components-configurable-wizards-ContactUsAlert-ContactUsAlert__link--ofEup"};